module.exports = __webpack_public_path__ + "static/media/blue_tick.d5027719.svg";